module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内待入库",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内入库",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已合箱",
      "name": "6"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内出库",
      "name": "four"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心入库",
      "name": "7"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心出库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "分舵入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "客户签收",
      "name": "five"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "six"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待补录",
      "name": "seven"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "monewt"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "运单号"
    },
    on: {
      "input": function($event) {
        return _vm.inputOrder(_vm.orderNOA)
      }
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户名/vip号"
    },
    on: {
      "input": function($event) {
        return _vm.realDate(_vm.orderNOC)
      }
    },
    model: {
      value: (_vm.orderNOC),
      callback: function($$v) {
        _vm.orderNOC = $$v
      },
      expression: "orderNOC"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [(_vm.activeName !== 'second') ? _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "派送点"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.addressId),
      callback: function($$v) {
        _vm.$set(_vm.search, "addressId", $$v)
      },
      expression: "search.addressId"
    }
  }, _vm._l((_vm.deliveryAddressList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.addressId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "箱号"
    },
    on: {
      "input": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "是否发货单"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.isOrderSend),
      callback: function($$v) {
        _vm.$set(_vm.search, "isOrderSend", $$v)
      },
      expression: "search.isOrderSend"
    }
  }, _vm._l((_vm.sendList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "search_lbl"
  }, [_vm._v("下单时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.value1)
      }
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), (_vm.activeName == 'four') ? _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("出库时间：")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate2(_vm.value2)
      }
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'third') ? _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("国内入库时间：")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'third') ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate4(_vm.value4)
      }
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five') ? _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("结算时间：")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five') ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate3(_vm.value3)
      }
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getOrderList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.activeName != 'first') ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出Excel")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'third') ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportToSendOrderLook();
        _vm.getNowData();
      }
    }
  }, [_vm._v("预览客户发货单")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToSendOrder()
      }
    }
  }, [_vm._v("批量生成发货单")]) : _vm._e()], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "height": "380",
      "stripe": "",
      "row-key": "orderId"
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select": _vm.selectChange,
      "row-click": _vm.handleRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center",
      "selectable": _vm.selectable,
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderSend) ? _c('span', {
          staticClass: "tag tag2"
        }, [_vm._v("已生成")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.productName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.deliveryTitle) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n          "), (scope.row.status == 1 || scope.row.status == 2) ? _c('div', {
          staticClass: "sign"
        }, [(scope.row.expressTime) ? _c('div', [_vm._v("\n              国内已签收(" + _vm._s(_vm.toDate(scope.row.expressTime, "yyyy-MM-dd")) + ")\n            ")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "115px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1 && scope.row.expressStatus == 0) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n            待签收\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1 && scope.row.expressStatus == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n            待入库\n          ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            已入库\n          ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已出库\n          ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已结单\n          ")]) : (scope.row.status == 5) ? _c('div', {
          staticStyle: {
            "color": "#eea381"
          }
        }, [_vm._v("\n            待补录\n          ")]) : (scope.row.status == 6) ? _c('div', {
          staticStyle: {
            "color": "#c0e781"
          }
        }, [_vm._v("\n            已合箱\n          ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n            已取消\n          ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （中心仓）已入库\n          ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            （中心仓）已出库\n          ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （派送）已入库\n          ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#008b8b"
          }
        }, [_vm._v("\n            可预约\n          ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#800080"
          }
        }, [_vm._v("\n            已预约\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收人",
      "width": "100px",
      "align": "center",
      "prop": "expressName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "尺寸",
      "prop": "measure",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积",
      "prop": "productVolume",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量",
      "prop": "productWeight",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "width": "100px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "补录时间",
      "min-width": "170px",
      "align": "center",
      "prop": "suppleTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.suppleTime ? _vm.changeToTime(scope.row.suppleTime) : "") + "\n        ")]
      }
    }])
  }), _vm._v(" "), (_vm.activeName == 'third') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "入库时间",
      "min-width": "90px",
      "align": "center",
      "prop": "storeDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "出库时间",
      "min-width": "90px",
      "align": "center",
      "prop": "deliveryDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "结算时间",
      "min-width": "90px",
      "align": "center",
      "prop": "statementDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '7') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "中心仓入库时间",
      "min-width": "110px",
      "align": "center",
      "prop": "statementDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTimes(scope.row, 1)) + "\n        ")]
      }
    }], null, false, 3998975071)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '8') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "中心仓出库时间",
      "min-width": "110px",
      "align": "center",
      "prop": "statementDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTimes(scope.row, 2)) + "\n        ")]
      }
    }], null, false, 2433945084)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '9') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "派送入库时间",
      "min-width": "110px",
      "align": "center",
      "prop": "storeTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTimes(scope.row, 3)) + "\n        ")]
      }
    }], null, false, 4276116637)
  }) : _vm._e(), _vm._v(" "), (
    _vm.activeName == 'four' ||
    _vm.activeName == '7' ||
    _vm.activeName == '8' ||
    _vm.activeName == '9'
  ) ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "所在箱",
      "min-width": "90px",
      "align": "center",
      "prop": "boxNumber"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five' || _vm.activeName == '9') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "货柜号",
      "min-width": "90px",
      "align": "center",
      "prop": "containerName"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "batchNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "90px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo, '2', scope.row)
            }
          }
        }, [_vm._v("入库")]) : _vm._e(), _vm._v(" "), (scope.row.status == 5) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.addOrderProductDialog(scope.row)
            }
          }
        }, [_vm._v("补录")]) : _vm._e(), _vm._v(" "), (scope.row.status != 5) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo)
            }
          }
        }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), [(_vm.activeName == 'third') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.delOrder(scope.row.orderNo)
            }
          }
        }, [_vm._v("取消")]) : _vm._e()]]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.activeName == 'third') ? _c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.openBoxHanlder()
      }
    }
  }, [_vm._v("合箱")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.openExcelBoxDialog()
      }
    }
  }, [_vm._v("Excel批量合箱")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showE,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showE", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您是否确认结单？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmD()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showE = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showG,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showG", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认改变该合箱状态嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmC()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showG = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showF,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showF", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认删除该图片嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmB()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showF = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showD,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "800px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showD", $event)
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "search",
    attrs: {
      "model": _vm.orderInfo,
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderNo) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.orderInfo.addDate) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 2) ? _c('div', [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.orderInfo.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "expressCompany", $$v)
      },
      expression: "orderInfo.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1) : _c('div', [_vm._v("\n                  " + _vm._s(_vm.orderInfo.expressCompany) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 2) ? _c('div', [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.orderInfo.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "expressNo", $$v)
      },
      expression: "orderInfo.expressNo"
    }
  })], 1) : _c('div', [_vm._v("\n                  " + _vm._s(_vm.orderInfo.expressNo) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                  待入库\n                ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n                  已入库\n                ")]) : _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v(" 已出库 ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    model: {
      value: (_vm.orderInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "remark", $$v)
      },
      expression: "orderInfo.remark"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("包裹重量KG：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productWeight),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productWeight", $$v)
      },
      expression: "orderInfo.productWeight"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lbl_title lbl_margin"
  }, [_vm._v("长CM：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productLong),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productLong", $$v)
      },
      expression: "orderInfo.productLong"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lbl_title lbl_margin"
  }, [_vm._v("宽CM：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productWidth),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productWidth", $$v)
      },
      expression: "orderInfo.productWidth"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lbl_title lbl_margin"
  }, [_vm._v("高CM：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productHeight),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productHeight", $$v)
      },
      expression: "orderInfo.productHeight"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1 lineHeight"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("货物类型：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "220px",
      "margin-left": "18px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "float": "left",
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择运输方式"
    },
    on: {
      "change": _vm.seleTransType
    },
    model: {
      value: (_vm.checkedTransType),
      callback: function($$v) {
        _vm.checkedTransType = $$v
      },
      expression: "checkedTransType"
    }
  }, _vm._l((_vm.transTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "120px",
      "margin": "-46px 0 0 130px"
    },
    attrs: {
      "placeholder": "物品类型"
    },
    on: {
      "change": _vm.seleTransGoods
    },
    model: {
      value: (_vm.checkedgoodsType),
      callback: function($$v) {
        _vm.checkedgoodsType = $$v
      },
      expression: "checkedgoodsType"
    }
  }, _vm._l((_vm.transGoodSelectArr), function(item) {
    return _c('el-option', {
      key: item.goodId,
      attrs: {
        "label": item.goodName,
        "value": item.goodId + ',' + item.price + ',' + item.firstWeight
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px",
      "margin-left": "48px"
    }
  }, [_vm._v("\n                价格系数：" + _vm._s(_vm.priceGoodsIdCopy.price) + "\n              ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("\n                首重计算："), (_vm.priceGoodsIdCopy.firstWeight == 1) ? _c('span', [_vm._v("是")]) : _c('span', [_vm._v("否")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', {
    staticClass: "wrl-leftig",
    class: _vm.weiTotal &&
      _vm.weiTotal > 0 &&
      Number(_vm.weiTotal) >= Number(_vm.volTotal) ?
      'backRed' :
      ''
  }, [_vm._v("\n                重量费用：CAD " + _vm._s(_vm.weiTotal) + "\n              ")]), _vm._v(" "), _c('div', {
    class: _vm.volTotal &&
      _vm.volTotal > 0 &&
      Number(_vm.volTotal) > Number(_vm.weiTotal) ?
      'backRed' :
      '',
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                体积费用：CAD " + _vm._s(_vm.volTotal) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList",
    staticStyle: {
      "margin": "40px 30px"
    }
  }, [_c('div', {
    staticClass: "wlr-header"
  }, [_c('div', {
    staticClass: "wlr-start"
  }, [_c('div', [_vm._v("商品清单")])]), _vm._v(" "), _c('div', [_vm._v("商品入库数据(每件商品数据)")]), _vm._v(" "), _c('div', {
    staticClass: "addProdauc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _c('div', _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n                  " + _vm._s(i + 1) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [(_vm.orderInfo.status == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-bottom": "18px"
      },
      attrs: {
        "prop": 'productList.' + i + '.productName',
        "rules": [{
          required: true,
          message: '商品名称不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "340px",
        "height": "30px"
      },
      model: {
        value: (val.productName),
        callback: function($$v) {
          _vm.$set(val, "productName", $$v)
        },
        expression: "val.productName"
      }
    })], 1)], 1) : _c('div', {
      staticClass: "ellipsisB",
      staticStyle: {
        "-webkit-box-orient": "vertical",
        "width": "370px"
      }
    }, [_vm._v("\n                    " + _vm._s(val.productName) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [(_vm.orderInfo.status == 2) ? _c('div', [_c('el-form-item', [_c('el-input', {
      staticStyle: {
        "width": "70px",
        "height": "30px"
      },
      attrs: {
        "disabled": ""
      },
      model: {
        value: (val.productNumB),
        callback: function($$v) {
          _vm.$set(val, "productNumB", $$v)
        },
        expression: "val.productNumB"
      }
    })], 1)], 1) : _c('div', [_vm._v("\n                        " + _vm._s(val.productNumB) + "\n                        件\n                      ")])]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                      " + _vm._s(val.productRemark) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx44",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "wrl-felx5 inpout",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticClass: "space"
    }, [_c('div', [_vm._v("入库数量")]), _vm._v(" "), _c('div', {
      staticClass: "inpoutTop"
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'productList.' + i + '.productNum',
        "rules": [{
          required: true,
          message: '入库数量不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "70px",
        "height": "30px"
      },
      model: {
        value: (val.productNum),
        callback: function($$v) {
          _vm.$set(val, "productNum", $$v)
        },
        expression: "val.productNum"
      }
    })], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "space"
    }, [_c('div', [_vm._v("货架")]), _vm._v(" "), _c('div', {
      staticClass: "inpoutTop"
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'productList.' + i + '.shelves'
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "70px",
        "height": "30px"
      },
      on: {
        "input": function($event) {
          return _vm.shelver(i, val, val.shelves)
        }
      },
      model: {
        value: (val.shelves),
        callback: function($$v) {
          _vm.$set(val, "shelves", $$v)
        },
        expression: "val.shelves"
      }
    })], 1)], 1)])])]), _vm._v(" "), _vm._l((val.productImgList), function(value, index) {
      return _c('div', {
        key: index,
        staticClass: "wrl-felx6"
      }, [_c('el-upload', {
        staticClass: "upload-demo",
        attrs: {
          "action": "",
          "headers": _vm.headers,
          "http-request": _vm.handleLicenseImgFile,
          "show-file-list": false,
          "before-upload": _vm.beforeAvatarUpload
        }
      }, [(value.productImg) ? _c('div', {
        staticClass: "pta",
        on: {
          "click": function($event) {
            return _vm.unpload(i, index)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-delete childe",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.del(i, index)
          }
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "avatar",
        class: index > 0 ? 'spaceLeft' : '',
        attrs: {
          "src": value.productImg
        }
      })]) : _vm._e()])], 1)
    }), _vm._v(" "), (val.productImgList.length < 2) ? _c('div', {
      staticClass: "wrl-felx6",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('el-upload', {
      staticClass: "upload-demo",
      attrs: {
        "action": "",
        "headers": _vm.headers,
        "http-request": _vm.handleLicenseImgFileB,
        "show-file-list": false,
        "before-upload": _vm.beforeAvatarUploadB
      }
    }, [_c('div', {
      staticClass: "backgroundA",
      staticStyle: {
        "width": "48px",
        "height": "48px"
      },
      on: {
        "click": function($event) {
          return _vm.unploadB(i)
        }
      }
    }, [_vm._v("\n                      上传\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (val.productImgList.length == 0) ? _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "48px",
        "height": "48px"
      }
    })]) : _vm._e()], 2)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrl-flex56"
  }, [_c('div', [_c('span', [_vm._v("折扣比率：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "input": function($event) {
        return _vm.changeDiscount(_vm.orderInfo.discount)
      },
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "discount", $$v)
      },
      expression: "orderInfo.discount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("优惠前价格：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n              CAD " + _vm._s(_vm._f("priceFilt")(_vm.total)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ec808d",
      "margin-left": "20px"
    }
  }, [_vm._v("\n            优惠后价格： CAD " + _vm._s(_vm._f("priceFilt")(_vm.discountTotal)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-flex57"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsubmitB()
      }
    }
  }, [_vm._v("提交")])], 1)])])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": "",
      "title": "修改最后费用值"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showC", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 0 10px 0"
    }
  }, [_vm._v("您确认修改嘛？")]), _vm._v(" "), _c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.cahnBlur(_vm.orderInfoC)
      }
    },
    model: {
      value: (_vm.orderInfoC),
      callback: function($$v) {
        _vm.orderInfoC = $$v
      },
      expression: "orderInfoC"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirm(_vm.orderInfoC)
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showC = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您是否将订单出库吗？该操作不可逆")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsubmit()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showB = false;
        _vm.dialog.show = false;
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }, [_c('el-row', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.instorage(_vm.orderInfo)
      }
    }
  }, [_vm._v("入库")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.delOrderDiolag(_vm.orderInfo)
      }
    }
  }, [_vm._v("取消订单")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editOrder(_vm.orderInfo)
      }
    }
  }, [_vm._v("编辑订单")])], 1) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.instorage(_vm.orderInfo)
      }
    }
  }, [_vm._v("重新入库")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editOrder(_vm.orderInfo)
      }
    }
  }, [_vm._v("编辑订单")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressNo))]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("商品价值：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.predictTotal))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n            待入库\n          ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n            已入库\n          ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已出库\n          ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已结单\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [(_vm.orderInfo.isBox == 1) ? _c('div', [_c('span', [_vm._v("合箱")])]) : _c('div', [_c('span', {
    staticClass: "red",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("不合箱")])])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [(_vm.orderInfo.status != 4) ? _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.getorderNoB(_vm.orderInfo.orderNo, _vm.orderInfo.isBox)
      }
    }
  }, [_vm._v("修改")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.orderInfo.suppleTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("补录时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.suppleTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.storeTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 3) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.centerEnterTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("中心入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.centerEnterTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.centerOutTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("中心出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.centerOutTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.deliveryEnterTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("派送入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryEnterTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.statementTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("派送出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.statementTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际尺寸：")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.orderInfo.productSize) + " CBM\n          "), _c('span', [_vm._v("（" + _vm._s(_vm.orderInfo.productLong) + "CM*" + _vm._s(_vm.orderInfo.productWidth) + "CM*" + _vm._s(_vm.orderInfo.productHeight) + "CM）")])])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际重量：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productWeight) + " KG")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', [_vm._v("最后费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [(_vm.orderInfo.status == 2) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.orderInfo)
      }
    }
  }, [_vm._v("修改")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单备注：")]), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.remark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.orderInfo.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.userRemark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status == 1) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n              " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "ellipsisBB",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(val.productName) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(val.productNum) + "件")]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productRemark) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [(val.shelves) ? _c('div', {
      staticStyle: {
        "color": "#ec808d"
      }
    }, [_vm._v("\n                货架: " + _vm._s(val.shelves) + "\n              ")]) : _vm._e()]), _vm._v(" "), (val.productImg) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImg)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImg,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })]), _vm._v(" "), (val.productImgB) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImgB)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImgB,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })])])])
  })], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showH,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "title": "编辑订单",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showH", $event)
      }
    }
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "model": _vm.order,
      "label-width": "55px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.order.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressCompany", $$v)
      },
      expression: "order.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.order.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressNo", $$v)
      },
      expression: "order.expressNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("商品价值：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "整单商品价值,单位元"
    },
    on: {
      "blur": function($event) {
        return _vm.checkOrder(_vm.order.predictTotal)
      }
    },
    model: {
      value: (_vm.order.predictTotal),
      callback: function($$v) {
        _vm.$set(_vm.order, "predictTotal", $$v)
      },
      expression: "order.predictTotal"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n              待入库\n            ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n              已入库\n            ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n              已出库\n            ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n              已结单\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入合箱状态"
    },
    model: {
      value: (_vm.order.isBox),
      callback: function($$v) {
        _vm.$set(_vm.order, "isBox", $$v)
      },
      expression: "order.isBox"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.order.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.order.userRemark))]) : _c('div', [_vm._v("无")])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', {
    staticClass: "flex22"
  }, [_c('div', {
    staticClass: "font"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addProduct()
      }
    }
  }, [_vm._v("\n                添加商品")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.order.detailList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n                " + _vm._s(i + 1) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-55px"
      },
      attrs: {
        "prop": 'detailList.' + i + '.productName',
        "rules": [{
          required: true,
          message: '商品名称不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (val.productName),
        callback: function($$v) {
          _vm.$set(val, "productName", $$v)
        },
        expression: "val.productName"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "-15px"
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-55px"
      },
      attrs: {
        "prop": 'detailList.' + i + '.productNum',
        "rules": [{
            required: true,
            message: '商品数量不能为空',
            trigger: 'blur',
          },
          {
            type: 'number',
            message: '商品数量必须为数字值'
          } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "商品数量"
      },
      model: {
        value: (val.productNum),
        callback: function($$v) {
          _vm.$set(val, "productNum", _vm._n($$v))
        },
        expression: "val.productNum"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDialog(i)
        }
      }
    }, [_vm._v("删除")])], 1)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex4"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitOrder()
      }
    }
  }, [_vm._v("提交")])], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定移除该商品信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.indexA)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showC", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定移除该商品信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItemB(_vm.indexA)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showC = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定取消该订单嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.delOrder(_vm.delOrderNo)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showB = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showCC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "540px",
      "title": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showCC", $event)
      }
    }
  }, [_c('div', {
    staticClass: "showFontSize"
  }, [_vm._v("批量生成发货单")]), _vm._v(" "), _c('div', {
    staticClass: "lineHeightTop"
  }), _vm._v(" "), _c('div', [_c('div', [_c('span', {
    staticStyle: {
      "width": "100px",
      "text-align": "right",
      "display": "inline-block"
    }
  }, [_vm._v("批量发货时间：")]), _vm._v(" "), _c('span', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择有效起始日期时间"
    },
    model: {
      value: (_vm.newDate),
      callback: function($$v) {
        _vm.newDate = $$v
      },
      expression: "newDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "100px",
      "text-align": "right",
      "display": "inline-block"
    }
  }, [_vm._v("发货单批次：")]), _vm._v(" "), _c('span', [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.sendDialog.remark),
      callback: function($$v) {
        _vm.$set(_vm.sendDialog, "remark", $$v)
      },
      expression: "sendDialog.remark"
    }
  })], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToOrder(_vm.newDate)
      }
    }
  }, [_vm._v("批量生成发货单")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showCC = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showD,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "540px",
      "title": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showD", $event)
      }
    }
  }, [_c('div', {
    staticClass: "showFontSize"
  }, [_vm._v("预览客户发货单")]), _vm._v(" "), _c('div', {
    staticClass: "lineHeightTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "showFlex"
  }, [_c('div', [_vm._v("客户VIP编号：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入客户VIP编号"
    },
    model: {
      value: (_vm.userIdCode),
      callback: function($$v) {
        _vm.userIdCode = $$v
      },
      expression: "userIdCode"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToOrderLook(_vm.userIdCode)
      }
    }
  }, [_vm._v("预览客户发货单")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showD = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showF,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showF", $event)
      }
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "min-width": "100px",
      "align": "center"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.orderAddDialog.show,
      "title": _vm.orderAddDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.orderAddDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "tab_address"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.orderAddDialog.activeName),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog, "activeName", $$v)
      },
      expression: "orderAddDialog.activeName"
    }
  }, _vm._l((_vm.storeList), function(item) {
    return _c('el-tab-pane', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "name": item.goodType
      }
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.contacts) + "," + _vm._s(item.tel))])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order_base"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.orderAddDialog.data,
      "rules": _vm.orderAddDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressNo",
      "label": "快递单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.orderAddDialog.data.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "expressNo", $$v)
      },
      expression: "orderAddDialog.data.expressNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "expressCompany",
      "label": "快递公司："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.orderAddDialog.data.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "expressCompany", $$v)
      },
      expression: "orderAddDialog.data.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价值："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "预估价值"
    },
    model: {
      value: (_vm.orderAddDialog.data.predictTotal),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "predictTotal", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderAddDialog.data.predictTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "备注："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.orderAddDialog.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderAddDialog.data.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("补录商品清单")]), _vm._v(" "), _c('el-button', {
    staticClass: "order_add",
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.addOrderProduct()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加商品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, _vm._l((_vm.orderAddDialog.data.productList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "p_item"
    }, [_c('span', {
      staticClass: "p_num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "p_name"
    }, [_c('el-input', {
      staticClass: "p_input",
      attrs: {
        "type": "text",
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (
          _vm.orderAddDialog.data.productList[index].productName
        ),
        callback: function($$v) {
          _vm.$set(_vm.orderAddDialog.data.productList[index], "productName", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "\n                  orderAddDialog.data.productList[index].productName\n                "
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "p_input",
      attrs: {
        "type": "text",
        "placeholder": "请输入商品数量"
      },
      model: {
        value: (
          _vm.orderAddDialog.data.productList[index].productNum
        ),
        callback: function($$v) {
          _vm.$set(_vm.orderAddDialog.data.productList[index], "productNum", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "\n                  orderAddDialog.data.productList[index].productNum\n                "
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('div', {
      staticClass: "p_del",
      on: {
        "click": function($event) {
          return _vm.deleteOrderProduct(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    })]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.supplementOrder()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.orderAddDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.boxDialog.show,
      "title": _vm.boxDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.boxDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.multipleSelection,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.productName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n              " + _vm._s(scope.row.goodName) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.userName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.vipCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.expressNo) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.deliveryTitle) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    on: {
      "click": _vm.submitBox
    },
    slot: "reference"
  }, [_vm._v("确认合箱")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.boxDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.mianDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "close": "closeMianDialog()",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.mianDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您已合箱完成，可选择：")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.mianHandler(1)
      }
    }
  }, [_vm._v("打印面单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.mianHandler(2)
      }
    }
  }, [_vm._v("合箱列表")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.excelBoxDialog.show,
      "title": "Excel批量合箱",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.excelBoxDialog, "show", $event)
      },
      "closed": _vm.handleExcelDialogClosed
    }
  }, [_c('div', {
    staticClass: "excel-upload-container"
  }, [_c('div', {
    staticClass: "upload-area"
  }, [_c('el-upload', {
    ref: "excelUpload",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "#",
      "before-upload": _vm.beforeUpload,
      "on-change": _vm.handleFileChange,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "file-list": _vm.excelBoxDialog.fileList,
      "auto-upload": false,
      "accept": ".xlsx,.xls"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将Excel文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('div', [_vm._v("只能上传Excel文件(.xlsx/.xls)，且不超过10MB")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("\n              Excel文件格式要求：第一列为运单号，系统将根据运单号自动分组合箱\n            ")])])])], 1), _vm._v(" "), (_vm.excelBoxDialog.uploadProgress.show) ? _c('div', {
    staticClass: "upload-progress"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.excelBoxDialog.uploadProgress.percentage,
      "status": _vm.excelBoxDialog.uploadProgress.status
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v(_vm._s(_vm.excelBoxDialog.uploadProgress.text))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.excelBoxDialog.show = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.excelBoxDialog.uploading,
      "disabled": _vm.excelBoxDialog.fileList.length === 0
    },
    on: {
      "click": _vm.submitExcelBoxing
    }
  }, [_vm._v("\n        " + _vm._s(_vm.excelBoxDialog.uploading ? '处理中...' : '开始合箱') + "\n      ")])], 1)]), _vm._v(" "), (_vm.mianDialog.isPrint) ? _c('Face', {
    attrs: {
      "boxId": _vm.mianDialog.boxId
    },
    on: {
      "closeFaceDialog": _vm.closeFaceDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5184b68b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/orderList.vue
// module id = 1241
// module chunks = 2